module.exports = __webpack_public_path__ + "assets/images/glasses-02.e0025b5bd1ff4dc79bce6b719a1d64b0.svg";